import { Action } from 'redux';
import { put, call } from 'redux-saga/effects';
import IActionWithEmitter from '../Application/IActionWithEmitter';
import { SagaIterator } from 'redux-saga';

export function* deliver<TAction extends Action>(action: TAction, timeoutMs: number = 10e3): SagaIterator {
	const actionWithEmitter: IActionWithEmitter = yield put<TAction>(action);
	yield call(
		() =>
			new Promise((resolve: (value?: never) => void, reject: (e: Error) => void) => {
				const timeout = setTimeout(() => reject(new Error(`Delivering action ${action.type} has timed out`)), timeoutMs);
				actionWithEmitter.__emitter.once('delivered', () => {
					clearTimeout(timeout);
					resolve();
				});
			}),
	);
	return action;
}
